import { Box, Stepper } from '@capitalise/ui-design-system';
import { useCreditLimitContext } from '../../hooks/useCreditLimitContext';
import { Confirmation, TopUp, YourOrder } from '../../components/CreditLimitSteps';
import { CreditLimitTopNav } from '../../components';

const CreditLimitSidePanel = () => {
  const { error, step } = useCreditLimitContext();
  const getStepContent = () => {
    switch (step) {
      case 1:
        return <TopUp />;
      case 2:
        return <YourOrder />;
      case 3:
        return <Confirmation />;
    }
  };

  const defaultStepperProps = { currentStep: step, steps: ['Top-up', 'Checkout', 'Confirmation'] };
  const errorStepperProps = {
    ...defaultStepperProps,
    color: 'danger',
    steps: ['Top-up', 'Checkout', 'Technical Error'],
    icon: null,
  };
  const getStepperProps = error ? errorStepperProps : defaultStepperProps;

  return (
    <Box height="100%" width="100%">
      <CreditLimitTopNav />
      <Stepper {...getStepperProps} />
      <Box px="xlarge" mt="medium">
        {getStepContent()}
      </Box>
    </Box>
  );
};

export default CreditLimitSidePanel;
